import { render, staticRenderFns } from "./integrations-banner.vue?vue&type=template&id=dd01593e"
import script from "./integrations-banner.vue?vue&type=script&lang=js"
export * from "./integrations-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports